export default __webpack_public_path__ + "static/media/BrainBreak cards13.b763bdab.png";